import { SearchResultFlat, SelectedSearchResult } from '@agissc/ktag-map';

const isMatchingSearchResult = (
  searchItem: SearchResultFlat,
  selectedResult: SelectedSearchResult | null,
) => {
  if (!selectedResult) return false;

  const { detail, label, origin } = searchItem;
  const { detail: selectedDetail, origin: selectedOrigin } = selectedResult;

  if (selectedOrigin && selectedOrigin !== origin) return false;

  const regex = new RegExp(`\\b${selectedDetail}\\b`, 'i');
  if (regex.test(detail)) return true;

  const normalizedLabel = label.replace(/(<([^>]+)>)/gi, '').toLowerCase();
  return regex.test(normalizedLabel);
};

export default isMatchingSearchResult;
